import { render, staticRenderFns } from "./TopRatedIndicators.vue?vue&type=template&id=32d99291&"
import script from "./TopRatedIndicators.vue?vue&type=script&lang=js&"
export * from "./TopRatedIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports